import ScrollTrigger from '@terwanerik/scrolltrigger';
import easing from 'jquery.easing';
import Vue from 'vue';
import VueCookies from 'vue-cookies';
//import Swiper from 'swiper/bundle';
//import Swiper, { Navigation } from 'swiper';
import Swiper from 'swiper';
import swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import lightcase from "lightcase";
import 'lightcase/src/css/lightcase.css';
import {gsap} from 'gsap';

export class App {
  constructor() {
    Vue.use(VueCookies);
    Vue.$cookies.config(Infinity);
    //Swiper.use([Navigation])
    this.html = document.documentElement;
    this.body = document.body;
    this.wrap = document.getElementById('wrap');
    this.home_url = home_url;
    this.tmp_url = tmp_url;
    this.speed = 900;
    this.ease = "easeInOutExpo";
    this.judge = 960;
    this.max_und = max_und;


    this.ua = isSp(this);
    this.sp = false;

    //console.log(this.home_url);


    function isSp(_t) {
      let _ua;
      if (navigator.userAgent.match(/iPhone|iPad|iPod|Android.+Mobile/)) {
        _ua = "mobile";
        _t.makeSp();
        //console.log(_t);
      } else {
        _ua = "other";
      }
      _t.body.classList.add(_ua);
      return _ua;
    }
  }
  init() {
    this.makeVue();
    this.page = document.getElementById('page');
    this.hero = document.getElementById('heroContainer');
    this.header = document.getElementById('masthead');
    this.site_branding = this.header.querySelector('.site-branding');
    this.navContainer = document.querySelector('.navContainer');
    this.menu = document.querySelector('.menu');
    this.item_archive = this.menu.querySelectorAll('.item-archive');

    if(this.body.classList.contains('home')){
      if(!ref_jud){
       
        this.tAnim = document.getElementById('topAnim');
        this.tLogo = document.getElementById('logo');
        this.tContainer = document.getElementById('topTxtContainer');
        this.tTxt1 = document.getElementById('topTxt1');
        this.tTxt2 = document.getElementById('topTxt2');
        this.tTxt3 = document.getElementById('topTxt3');
        this.tTxt4 = document.getElementById('topTxt4');
        this.tTxt5 = document.getElementById('topTxt5');

        this.TL = gsap.timeline({
          defaults: {
            duration: 1
          }
        });
        this.TL.set(this.tContainer,{
          // opacity:0,
          // x:-10
        }).set(this.tLogo,{
          opacity:0,
          scale:.7
        }).set(this.tTxt1,{
          opacity:0,
          scale:1.6
        }).set(this.tTxt2,{
          opacity:0,
          scale:1.6
        }).set(this.tTxt3,{
          opacity:0,
          scale:1.6
        }).set(this.tTxt4,{
          opacity:0,
          scale:1.6
        }).set(this.tTxt5,{
          opacity:0,
          scale:1.6
        })
        ;
      }
    }

    this.makeSpParts();
    this.getSize();


    window.addEventListener('load', e => {
      const _this = this;
      setTimeout(() => {
        if(ref_jud){
          this.firstShow();
        }
        this.events();
      }, 700);
    });



    if (this.body.classList.contains('single-post')) {
      const yts = document.querySelectorAll('iframe[title*="YouTube"]');
      console.log(yts);
      if (yts.length) {
        for (const yt of yts) {
          yt.outerHTML = `<div class="ytWrapper">${yt.outerHTML}</div>`;
        }
      }
    }

  }
  firstShow(){
    this.html.classList.remove('fix');
    this.html.classList.add('on');
    this.wrap.classList.add('on');
    $('.spinner').fadeOut('slow', function () {
      $(this).remove();
    });
  }
  makeVue() {
    this.vue_app = new Vue({
      el: "#page",
      data: {
        message: 'First Oops!',
        bgCol: "wh",
        pageUrl: '/mylist',
        myList_url: app.home_url + this.pageUrl,
        inhart: false,
        logoSrc: app.tmp_url + '/images/common/img_logo_spoke_w.png',
        //entryContent: document.getElementById('entryContent'),
        ids: ''
      },
      computed: {
        setColor: function () {
          return this.bgCol;
          console.log("col_" + bgCol);
        }
        // setList: function(){
        //   return function(id){
        //     let _ids = id;
        //       if(this.$cookies.get('myList')){
        //          _ids = this.$cookies.get('myList')+","+id;
        //       }
        //       this.setCookie('myList',_ids);
        //     return {on:true}
        //   }
        // }
      },
      methods: {
        init() {
          //console.log(app);
          this.checkCookie();

        },
        checkCookie() {
          console.log('checkCookie');
          if (this.$cookies.get('bgCol')) {
            const _col = this.$cookies.get('bgCol');
            this.bgCol = _col;
            this.changeSrc();
            //app.wrap.classList.add(_col);
          }
          if (this.$cookies.get('myList')) {
            this.ids = this.$cookies.get('myList').split(',');
            console.log(this.ids);
            if (this.ids) {
              if (app.body.classList.contains('home') ||
                app.body.classList.contains('mylist') ||
                app.body.classList.contains('tag') ||
                app.body.classList.contains('archive') ||
                app.body.classList.contains('single-member')) {
                console.log('check home');
                const worksList = document.querySelectorAll('.worksList__item');
                for (const item of worksList) {
                  const item_id = item.getAttribute('id').replace('item-', '');
                  item.querySelector('.btn_fav').classList.remove('on');
                  if (this.ids.indexOf(item_id) > -1) {
                    item.querySelector('.btn_fav').classList.add('on');
                  }
                }
                // for(const _id of this.ids){
                //   console.log(document.querySelector('.item-'+_id+' .btn_fav'));
                //   document.querySelector('.item-'+_id+' .btn_fav').classList.add('on');
                // }
              } else if (app.body.classList.contains('single-works')) {
                const _id = document.querySelector('.entry').getAttribute('id').replace('post-', '');
                if (this.ids.indexOf(_id) > -1) {
                  document.querySelector('.btn_fav').classList.add('on');
                }
              }
              // this.setUrl(this.ids);
            }

          }
          this.setUrl(this.ids);
          this.countCookie();
        },
        setCol(col) {
          this.bgCol = col;
          this.setCookie('bgCol', col);
          this.changeSrc();
          //console.log(this.$cookies.get('bgCol'));
          //app.wrap.classList.add(col);
        },
        setList(e, id) {
          //console.log(e.currentTarget);
          const _target = e.currentTarget;

          // if(e.currentTarget.classList.contains('on')){
          //   e.currentTarget.classList.remove('on');
          // }else{
          //   e.currentTarget.classList.add('on');
          // }

          let _ids = id;
          if (this.$cookies.get('myList')) {
            let _arr = this.$cookies.get('myList').split(',');//配列へ
            const _id = String(id);
            console.log(_arr);
            console.log(id);

            console.log("num=" + _arr.indexOf(_id));
            if (_arr.indexOf(_id) > -1) { //配列にidがあれば削除
              const num = _arr.indexOf(_id);
              console.log('find=' + num);
              _arr.splice(num, 1);
              _ids = _arr.join(',');
              _target.classList.remove('on');
              console.log(_ids);
              this.removeC(id, _ids);
            } else {//配列にidがなければ追加
              console.log('no');
              _target.classList.add('on');
              _ids = this.$cookies.get('myList') + "," + id;
            }
            //console.log(_arr);

          } else {// cookies がなければ最初のmylistとしてidを登録する。ここではonにするだけ
            _target.classList.add('on');
          }
          this.setUrl(_ids);
          this.setCookie('myList', _ids);
        },
        setUrl(_ids) {
          console.log(_ids);
          this.myList_url = app.home_url + this.pageUrl + "?ids=" + _ids;
          // if(_ids){
          //   this.myList_url = app.home_url+this.pageUrl + "?ids=" + _ids;
          // }else{
          //   this.myList_url = app.home_url+this.pageUrl + "?ids=";
          // }
        },
        setCookie(name, col) {
          //console.log(col);
          this.$cookies.set(name, col);
          console.log(this.$cookies.get(name));
          this.countCookie();

        },
        countCookie() {
          if (this.$cookies.get('myList') !== null) {
            this.inhart = true;
            //console.log("num="+this.$cookies.get('myList').split(',').length);
          } else {
            this.inhart = false;
            //console.log('no cookie');
          }

        },
        changeSrc() {
          console.log('change col');
          if (this.bgCol === "wh") {
            this.logoSrc = app.tmp_url + '/images/common/img_logo_spoke_w.png';
          } else if (this.bgCol === "bk") {
            this.logoSrc = app.tmp_url + '/images/common/img_logo_spoke_b.png';
          }
        },
        removeC(id, _ids = "") {
          //console.log('remove');
          if (id) {
            const _item = document.getElementById('item-' + id);

            if (app.body.classList.contains('mylist')) {
              history.replaceState('', '', this.pageUrl + "?ids=" + _ids);

              $(_item).fadeOut('500', function (e) {
                $(this).remove();
              });
              const _items = document.querySelectorAll('.worksList__item');
              //console.log('ids=' + _ids);
              if (!_ids) {
                document.getElementById('entryContent').innerHTML = `<p class="notfound">Not Found</p>`;
              }
            }
          } else {


            this.$cookies.remove('myList');
            this.setUrl("");
            this.inhart = false;
            console.log(this.myList_url);
            //window.location.href = this.myList_url;
            history.replaceState('', '', this.pageUrl + "?ids=");
            const entryContent = document.getElementById('entryContent');
            const _child = entryContent.querySelector(':scope > *');
            //entryContent.removeChild(_child);

            $(_child).fadeOut(500, function (e) {
              $(this).remove();
              entryContent.innerHTML = `<p class="notfound">Not Found</p>`;
            });
          }

        }
      }
    });
  }
  makeSpParts() {
    console.log('makespparts');
    this.btn_hum = document.createElement('div');
    this.btn_hum.classList.add('btn_hum');
    this.btn_hum.innerHTML = `
    <div class="btn_inner"><span class="bar colx"></span>
    <span class="bar colx"></span>
    <span class="bar colx"></span></div>`;
    this.site_branding.appendChild(this.btn_hum);
    // console.log(this.btn_hum);
    // console.log('make parts');
  }
  makeSp() {

  }
  getSize() {
    this.winW = window.innerWidth;
    console.log("w=" + this.winW);
    if (this.winW >= this.judge) {
      this.sp = false;
    } else {
      this.sp = true;
    }
    this.setSize();
  }
  setSize() {
    //console.log('setSize');
    if (this.sp) {
      this.header.classList.add('in');
      this.btn_hum.querySelector('.bar:nth-child(1').style.animationName = "";
      this.btn_hum.querySelector('.bar:nth-child(3)').style.animationName = "";
      //console.log(this.sp);
    } else {
      this.header.classList.remove('in');
      this.header.classList.remove('on');
      //this.menuclose();
      for (const list_item of this.item_archive) {
        const _w = list_item.querySelector('.termsListWrapper');
        _w.style.maxHeight = "";

        const _btn = list_item.querySelector('.btn_sub');
        //console.log(_btn);
        if (_btn !== null) {
          _btn.classList.remove('on');
        }
        // if(_btn.classList.contains('on')){
        //
        // }

      }
    }
  }
  events() {

    if(this.body.classList.contains('home')){
      if(!ref_jud){
        this.TL.to(this.tLogo,{
          delay:.2,
          opacity:1,
          scale:1,
          rotation:360,
          ease: "power3.inOut",
          duration:3
        })
        .to('.t-txt',{
          opacity:1,
          scale:1,
          duration:1.5,
          stagger: .17
        },"-=1.2")
        .to(this.tLogo,{
          opacity:0,
          duration:.5,
          ease:"none"
        },'close')
        .to('.t-txt',{
          opacity:0,
          duration:.5,
          ease:"none"
        },'close')
        .to(this.tAnim, {
          opacity:0,
          duration:1.5,
          ease: "none",
          complete:() => {
            setTimeout(() => {
              $(this.tAnim).remove();
              console.log('comp');
            },1500);
          }
        });

       this.firstShow();

      }
    }

    this.vue_app.init();
    //console.log(document.querySelector('.swiper') != null);

    if (document.querySelector('.swiper') != null) {

      // $('a[data-rel^=lightcase]').lightcase({
      //   maxHeight: 2000,
      //   maxWidth: 2000
      // });

      //console.log(lgList);
      //console.log(document.querySelectorAll('.swiper-sliderWrapper .swiper-slide').length);
      let swObj = {
        centeredSlides: true,
        speed: 1000,
        loop: true,
        
        effect: "fade",
        slidesPerView: 1,
        loopedSlides:3,
        fadeEffect: {
          crossFade: true
        },
        autoplay: {
          delay:4000,
          disableOnInteraction:false
        },
        // loopAdditionalSlides: 1,
        // reverseDirection: false,
        navigation: {
          nextEl: '.slider-btn-next',
          prevEl: '.slider-btn-prev',
        },
        breakpoints: {
          640: {
            loopedSlides: 5
          },
          840: {
            loopedSlides: 7
          }
        }
      };
      let swObj2 = {
        speed: 1000,
        loop: true,
        slidesPerView: 3,
        //slidesPerGroup: 3,
        //slidesPerView: 'auto',
        centeredSlides: true,
        slideToClickedSlide: true,
        // autoplay: {
        //   delay:4000,
        //   disableOnInteraction:false
        // },
        navigation: {
          nextEl: '.thumbnail-btn-next',
          prevEl: '.thumbnail-btn-prev',
        },
        breakpoints: {
          640: {
            slidesPerView: 5
          },
          840: {
            slidesPerView: 7
          }
        }
      };

      const sl_length = document.querySelectorAll('.swiper-sliderWrapper .swiper-slide').length;


     

     

      // if (sl_length <= 5) {
      //   swObj.thumbs = {
      //     swiper: thumbSlider
      //   }
      // }

      // if(sl_length > 1){

      //if (sl_length > 5) {

      // mainSlider.on('slideChange', () => {
      //   thumbSlider.slideToLoop(mainSlider.realIndex);
      // });

      // thumbSlider.on('slideChange', () => {
      //   mainSlider.slideToLoop(thumbSlider.realIndex);
      // });

      if(sl_length <= this.max_und){
        swObj2.loop = false;
        // swObj2.slidesPerView = 'auto';
        // swObj2.navigation = false;
        swObj2.centeredSlides = false;

      }

      if (sl_length == 1) {
        swObj.loop = false;
      }

      if(sl_length > 1 ){

      const thumbSlider = new Swiper('.thumbnail', swObj2);

      if(sl_length <= this.max_und){
        swObj.thumbs = {
          swiper: thumbSlider
        }
      }

      const mainSlider = new Swiper('.slider', swObj);

      if(sl_length > this.max_und){
      mainSlider.controller.control = thumbSlider;
      thumbSlider.controller.control = mainSlider;
      }

    }else{
      const mainSlider = new Swiper('.slider', swObj);
    }


     

     

      // }else{
      //   console.log('<= 1');
      // }

      //}

      $('a[data-rel^=lightcase]').lightcase({
        maxHeight: 2000,
        maxWidth: 2000
      });

    }






    
    const _this = this;
    window.onpageshow = function (event) {
      if (event.persisted) {
        console.log('reload');
        //window.location.reload();
        console.log(_this);
        _this.vue_app.checkCookie();
      }
    };



    window.matchMedia("(max-width:959px)").addListener(() => {
      if (window.matchMedia("(min-width:958px)").matches) {
        //console.log('out');
        // this.header.classList.remove('in');
        // this.header.classList.remove('on');
        this.sp = false;
        this.setSize();
      } else {
        // this.header.classList.add('in');
        // console.log(this.sp);
        this.sp = true;
        this.setSize();
      }

    });



    for (const list_item of this.item_archive) {

      const _btn = document.createElement('div');
      _btn.classList.add('btn_sub');
      list_item.appendChild(_btn);

      _btn.addEventListener('click', e => {
        const _this = e.currentTarget;
        const _pa = _this.closest('li');
        const _w = _pa.querySelector('.termsListWrapper');
        let _h = 0;

        if (_this.classList.contains('on')) {
          _this.classList.remove('on');
        } else {
          _this.classList.add('on');
          _h = _pa.querySelector('.termsList').clientHeight;
        }
        _w.style.maxHeight = _h + "px";
      });

      if (this.ua !== "mobile") {

        list_item.addEventListener('mouseover', e => {
          //console.log(this.sp);
          if (this.sp) {
            return false;
          }
          const _w = list_item.querySelector('.termsListWrapper');
          const listH = list_item.querySelector('.termsList').clientHeight;
          _w.style.maxHeight = listH + "px";
        });
        list_item.addEventListener('mouseout', e => {
          if (this.sp) { return false; }
          const _w = list_item.querySelector('.termsListWrapper');
          _w.style.maxHeight = 0;
        });

        const items = list_item.querySelectorAll('.termsList-item a');
        for (const _item of items) {
          _item.addEventListener('mouseover', e => {
            _item.classList.remove('col1');
            _item.classList.add('col3');
          });
          _item.addEventListener('mouseout', e => {
            _item.classList.remove('col3');
            _item.classList.add('col1');
          });
        }
      }
    }


    this.btn_hum.addEventListener('click', e => {
      if (this.header.classList.contains('on')) {
        //this.header.classList.remove('on');
        this.menuclose();
      } else {
        //this.header.classList.add('on');
        this.menuopen();
      }
    });
    
    

  }
  menuopen() {
    this.header.classList.add('on');
  }
  menuclose() {
    console.log('menuclose');

    this.header.classList.remove('on');

    this.btn_hum.querySelector('.bar:nth-child(1').style.animationName = "bar1";
    this.btn_hum.querySelector('.bar:nth-child(3)').style.animationName = "bar3";

  }
}
